module.exports = __webpack_public_path__ + "static/img/daniel.d56c1107.jpg";